<template>
  <div
    :id="context?.id"
    :aria-labelledby="`${context?.id}_label`"
    class="flex flex-wrap mt-2"
    :class="{ 'flex-col gap-2': context.vertical, 'gap-3': !context.vertical }"
  >
    <div v-for="option in context.options" :key="option.id" class="flex items-center">
      <FormKitRadioWithLabel
        :name="option[context.optionName]"
        :value="option[context.optionValue]"
        :model-value="context.value"
        :data-test-id="`${context.attrs['data-test-id']}-${option.id}`"
        @update:model-value="input"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'

const props = defineProps<{
  context: FormKitFrameworkContext<string> & { optionName: string; optionValue: string }
}>()

const input = async (value: string | undefined) => {
  await props.context.node.input(value)
  props.context.node.emit('updateValue', value)
}
</script>
